import { Calendar as PrimeReactCalendar } from 'primereact/calendar';
import { classNames } from 'primereact/utils';
import { useRef, type CSSProperties } from 'react';

import { Constants } from '../../utils/Constants';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { ReactComponent as CalendarIcon } from '../../assets/images/calendar-icon.svg';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { ReactComponent as TimeIcon } from '../../assets/images/clock.svg';

interface Props {
    id: string;
    label?: string;
    showLabel?: boolean;
    value?: Date | null;
    onChange?: (event: any) => void;
    disabled?: boolean;
    readOnlyInput?: boolean;
    showButtonBar?: boolean;
    dateFormat?: string;
    className?: string;
    inputClassName?: string;
    inputStyle?: CSSProperties;
    panelClassName?: string;
    timeOnly?: boolean;
    placeholder?: string;
    iconPosition?: 'left' | 'right';
    showIcon?: boolean;
    [key: string]: any;
}

const CalendarInput: React.FC<Props> = ({
    id,
    label,
    showLabel = true,
    readOnlyInput = true,
    showButtonBar = true,
    dateFormat = Constants.DATE_FORMAT_CALENDAR,
    className,
    inputClassName,
    inputStyle,
    panelClassName,
    timeOnly,
    disabled,
    iconPosition = 'right',
    showIcon = true,
    ...rest
}) => {
    const ref = useRef<any>(null);

    const inputId = `calendar-${id}`;

    const inputIsSmall =
        typeof inputClassName === 'string' &&
        inputClassName.includes('small');

    const openCalendar = () => {
        if (disabled) {
            return;
        }

        ref.current?.show();
    };

    const iconStyle: CSSProperties = {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 2,
        width: '20px',
        height: '20px',
        ...(iconPosition === 'left'
            ? {
                left: '12px',
            }
            : {
                right: '12px',
            }),
    };

    const resolvedInputStyle: CSSProperties = {
        ...inputStyle,

        ...(showIcon && iconPosition === 'left'
            ? {
                paddingLeft: '44px',
            }
            : {}),

        ...(showIcon && iconPosition === 'right'
            ? {
                paddingRight: '44px',
            }
            : {}),
    };

    const icon = timeOnly ? (
        <TimeIcon
            className={classNames(
                'cursor-pointer calendar-input__icon',
                {
                    small: inputIsSmall,
                }
            )}
            style={iconStyle}
            onClick={openCalendar}
        />
    ) : (
        <CalendarIcon
            className={classNames(
                'cursor-pointer calendar-input__icon',
                {
                    small: inputIsSmall,
                }
            )}
            style={iconStyle}
            onClick={openCalendar}
        />
    );

    return (
        <div
            className={classNames({
                field: showLabel,
            })}
        >
            {showLabel && label && (
                <label htmlFor={inputId}>
                    {label}
                </label>
            )}

            <span
                className="w-full calendar-input"
                style={{
                    position: 'relative',
                    display: 'block',
                    width: '100%',
                }}
            >
                <PrimeReactCalendar
                    {...rest}
                    id={inputId}
                    ref={ref}
                    disabled={disabled}
                    timeOnly={timeOnly}
                    readOnlyInput={readOnlyInput}
                    showButtonBar={showButtonBar}
                    dateFormat={dateFormat}
                    inputClassName={inputClassName}
                    inputStyle={resolvedInputStyle}
                    className={classNames(
                        'w-full',
                        className,
                        {
                            small: inputIsSmall,
                        }
                    )}
                    panelClassName={classNames(
                        panelClassName,
                        {
                            small: inputIsSmall,
                        }
                    )}
                />

                {showIcon && icon}
            </span>
        </div>
    );
};

export default CalendarInput;